module.exports = __webpack_public_path__ + "img/icon-usp-world.496fedf0.svg";